import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'pusher',
    key: '1dcbeef0a563eb4c8be7', // Use environment variables for secure keys
    cluster: 'eu',
    forceTLS: true,
});

export default echo;
